import { memo } from "react";
import "./GradientBackground.css";
import useSessionStorage from "@mirage/hooks/useSessionStorage";

const GradientBackground = memo(() => {
    const [sessionStorage] = useSessionStorage("publicportal");
    const gradientLeftColor = sessionStorage?.clientSettings?.GRADIENT_LEFT_COLOR || "#0357a6";
    const gradientRightColor = sessionStorage?.clientSettings?.GRADIENT_RIGHT_COLOR || "#188484";
    const background = `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(89.92deg, ${gradientLeftColor} 0.08%, ${gradientRightColor} 86.41%, ${gradientRightColor} 99.93%)`;
    return (
        <div className="gradientContainer">
            <div style={{ background }} className="gradientContainer__background"></div>
            <svg className="gradient__svg" viewBox="0 0 1920 90" focusable="false" role="presentation" preserveAspectRatio="none">
                <defs className="gradient__svg__defs"></defs>
                <path className="gradient__svg__path" d="M1920,90H0V0S374.51,89,960.06,89,1920,0,1920,0Z"></path>
            </svg>
        </div>
    );
});

export default GradientBackground;
